import { createContext } from "react";

const DesktopContext = createContext();

export default DesktopContext;
